import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/form-ok.svg")